<template>
  <div class="login-form">
  <FormulateForm
    class="login-form"
    v-model="credentials"
    @submit="submit"
    #default="{ isLoading }"
  >
    <FormulateInput
      name="username"
      type="text"
      label="Your username"
      placeholder="Your username"
      validation="required"
    />
    <FormulateInput
      name="password"
      type="password"
      label="Password"
      placeholder="Your password"
      validation="required"
    />
    <FormulateInput
      type="submit"
      :disabled="isLoading"
      :label="isLoading ? 'Logging in...' : 'Log In'"
    />
  </FormulateForm>
  </div>
</template>

<script>

import Role from '../../enums/role'

export default {
  name: 'LoginForm',
  data () {
    return {
      credentials: {
        username: null,
        password: null
      }
    }
  },
  methods: {
    async submit (credentials) {
      const result = await this.$store.dispatch('auth/login', credentials)
      if (result === 200) {
        const user = this.$store.getters['auth/user']
        if (user == null) {
          this.$router.push({name: 'screen'})
          return
        }
        if (user.hasRole(Role.PRESIDENT)) {
          this.$router.push({name: 'presidents_screen'})
        } else {
          this.$router.push({name: 'screen'})
        }
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Log in error',
          detail: result.body.error_description,
          life: 3000
        })
      }
    }
  }
}
</script>

<style scoped>
.login-form {
  min-width: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/LoginForm.vue